
import React from "react";
import { Phone } from "lucide-react";
import { useTheme } from "@/components/ThemeProvider";
import { AssistantData } from "@/types/assistant";
import { Avatar, AvatarImage } from "@/components/ui/avatar";

interface ChatHeaderProps {
  assistantData?: AssistantData | null;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ assistantData }) => {
  const { theme, setTheme } = useTheme();
  
  // Use "alfie" as fallback if no assistant name is set
  const assistantName = assistantData?.assistant_data?.assistantName || 'alfie';
  const tagline = assistantData?.assistant_data?.description || '';
  const phoneNumber = assistantData?.assistant_data?.hotel_details?.phone || '';
  const assistantAvatar = assistantData?.assistant_data?.avatar;
  const hotelName = assistantData?.assistant_data?.hotel_details?.name || '';
  
  // Format the title to include hotel name if available
  const headerTitle = hotelName ? `alfie — ${hotelName}` : 'alfie';

  return (
    <header className="flex items-center justify-center px-4 py-3 bg-[#F4F1ED] text-black">
      <div className="flex items-center space-x-3">
        {assistantAvatar && (
          <Avatar>
            <AvatarImage src={assistantAvatar} alt={`${assistantName}'s avatar`} />
          </Avatar>
        )}
        <div className="flex flex-col">
          <h1 className="font-family font-medium text-2xl">{headerTitle}</h1>
          {tagline && <p className="text-xs text-gray-600">{tagline}</p>}
        </div>
        {phoneNumber && (
          <div className="flex items-center gap-2">
          
            <a 
              href={`tel:${phoneNumber}`} 
              className="rounded-full p-2 hover:bg-gray-200 transition-colors"
              aria-label="Call hotel"
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Phone className="h-5 w-5 text-gray-600" />
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default ChatHeader;
